import React, { useRef, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowRightFromBracket,
  faChevronDown,
} from "@fortawesome/free-solid-svg-icons";
import Avatar from "./Avatar";
import useOutsideInteraction from "../hooks/useOutsideInteraction";
import useNewLogoutAPI from "../../../api/logoutAPI";

export default function SidebarUserMenu({ session }) {
  const [open, setOpen] = useState(false);
  const menuRef = useRef(null);
  const { logout } = useNewLogoutAPI();

  useOutsideInteraction(menuRef, open, () => setOpen(false));

  return (
    <div className="new-sidebar-user" ref={menuRef}>
      <button
        type="button"
        className="new-sidebar-user__trigger"
        aria-expanded={open}
        onClick={() => setOpen((value) => !value)}
      >
        <Avatar
          src={session?.userImageUrl}
          alt={session?.userName}
          className="new-sidebar-user__avatar"
          fit="cover"
        />
        <span className="new-sidebar-user__content">
          <strong>{session?.userName || "User"}</strong>
          <small>{session?.entityName || ""}</small>
        </span>
        <FontAwesomeIcon
          icon={faChevronDown}
          className={`new-sidebar-user__chevron ${open ? "is-open" : ""}`}
        />
      </button>

      {open ? (
        <div className="new-sidebar-user__menu">
          <button type="button" className="new-sidebar-user__action" onClick={logout}>
            <FontAwesomeIcon icon={faArrowRightFromBracket} />
            <span>Logout</span>
          </button>
        </div>
      ) : null}
    </div>
  );
}

